module.exports = __webpack_public_path__ + "img/bg.317c24da.jpg";